<script setup lang="ts">
import { UiIcon } from "@shopexperts/shared";
import { getToneNodeClasses, type WalletTimelineState } from "./walletTransactionDisplay";

defineProps<{
  state: WalletTimelineState;
  isLast?: boolean;
}>();
</script>

<template>
  <div class="relative hidden w-8 shrink-0 justify-center pt-3 sm:flex">
    <span
      v-if="!isLast"
      aria-hidden="true"
      class="absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2 bg-se-gray-200"
    />
    <span
      class="relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ring-4 ring-secondary"
      :class="getToneNodeClasses(state.tone)"
      :aria-label="state.label"
    >
      <UiIcon :name="state.icon" class="h-4 w-4" />
    </span>
  </div>
</template>
